import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, MenuItem } from 'primeng/api';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ColumnConfig, TABLE_CONFIG } from '../../../backoffice/components/dashboard/table-config';
import { ResponsibleRegistryService } from '../../../backoffice/services/responsible-registry.service';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Toast } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { ProfessionalsGeneralDataComponent } from './professionals-general-data/professionals-general-data.component';

@Component({
  selector: 'app-professionals-personal-info',
  providers: [DialogService, MessageService],
  imports: [
    CommonModule,
    DynamicDialogModule,
    Toast,
    BreadcrumbModule,
    ButtonModule,
    ProfessionalsGeneralDataComponent,
  ],
  templateUrl: './professionals-personal-info.component.html',
  styleUrl: './professionals-personal-info.component.scss',
})
export class ProfessionalsPersonalInfoComponent {
  private dialogService = inject(DialogService);
  private responsibleService = inject(ResponsibleRegistryService);
  private messageService = inject(MessageService);
  private router = inject(Router);

  // Table configuration
  tableTitle = 'Responsabili Registrati';
  tableIcon = 'pi-users';
  columns: ColumnConfig[] = [];
  data = signal<any[]>([]);
  loading = signal<boolean>(false);
  breadcrumbItems = signal<MenuItem[]>([{ label: 'Professionals Personal Info Dashboard' }]);
  showGeneralDataCard = signal<boolean>(false);

  ngOnInit(): void {
    this.checkUrlForCardDisplay();
    this.loadConfiguration();
    this.loadManagers();
  }

  private checkUrlForCardDisplay(): void {
    const currentUrl = this.router.url;
    this.showGeneralDataCard.set(currentUrl.includes('professionals-general-data'));
  }

  private loadConfiguration(): void {
    const config = TABLE_CONFIG['elencoResponsabili'];
    if (config) {
      this.columns = config.columns;
    }
  }

  private loadManagers(): void {
    this.loading.set(true);
    this.responsibleService.getResponsibles().subscribe({
      next: (response) => {
        if (response?.status && response?.data) {
          const dataArray = Array.isArray(response.data) ? response.data : [response.data];
          const mappedData = dataArray.map((manager: any) => ({
            ...manager,
            createdAt: manager.createdAt
              ? new Date(manager.createdAt).toLocaleDateString('it-IT')
              : '',
          }));
          this.data.set(mappedData);
        } else {
          console.warn('Unexpected API response format:', response);
          this.messageService.add({
            severity: 'warn',
            summary: 'Attenzione',
            detail: 'Formato dati non valido ricevuto dal server',
            life: 4000,
          });
          this.data.set([]);
        }
        this.loading.set(false);
      },
      error: (error: any) => {
        console.error('Error loading managers:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore nel recupero dei dati',
          detail: "Impossibile caricare l'elenco dei responsabili. Riprova più tardi.",
          life: 5000,
        });
        this.data.set([]);
        this.loading.set(false);
      },
    });
  }

  // =====================
  // EVENT HANDLERS
  // =====================
  onDetailClick(rowData: any): void {
    if (rowData?.id) {
      this.router.navigate(['/axa/dpo', rowData.id]).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  onExport(): void {
    // TODO: Implement export functionality
    this.messageService.add({
      severity: 'info',
      summary: 'Export',
      detail: 'Funzionalità di export in sviluppo',
      life: 3000,
    });
  }

  onClearFilters(): void {
    // Reset data to original
    this.loadManagers();
  }

  goToDpoWizard(): void {
    // TODO: Create manager registration wizard route
    this.messageService.add({
      severity: 'info',
      summary: 'Navigazione',
      detail: 'Wizard registrazione responsabile in sviluppo',
      life: 3000,
    });
  }
}
